module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"archive":"Archive","unarchive":"Unarchive","copy":"Copy","pasteScreenSpecs":"Paste screen specs","link":"View on Amazon","ports":{"hdmi":"HDMI","displayPort":"DisplayPort","thunderbolt":"Thunderbolt","usb3c":"USB 3C","usb3a":"USB 3A","usb2":"USB 2"},"price":"Price","under":"Under {0}"}}')
  delete Component.options._Ctor
}
